module.exports = __webpack_public_path__ + "img/shop6.e9ac2d4a.png";